import {ReactElement} from "react";
import {
    AttributePropertiesFormProps,
    AttributePropertiesPlugin
} from "./AttributePropertiesPlugin";
import {
    AttributePropertiesDto,
    AttributePropertiesType,
} from "../../../../../common/apis/stereotype/AttributeDefinitionDto";
import {CurrencySelectField} from "../../../../../components/fields/select/CurrencySelectField";
import {StereotypesTranslationKey} from "../StereotypesTranslationKey";
import {t} from "../../../../../store/localization/TranslMessasge";
import {CoreDataType} from "../../../../../common/apis/datatype/DataTypeDefinitionDto";

export class CurrencyAttributePropertiesPlugin implements AttributePropertiesPlugin {

    getSupportedCoreDataType(): string {
        return CoreDataType.CURRENCY;
    }

    getInitialValue(): AttributePropertiesDto {
        return {
            type: AttributePropertiesType.CURRENCY,
            currencyCode: null
        };
    }

    validate(attributeProperties: AttributePropertiesDto): Record<string, string> {
        return {};
    }

    renderForm({editMode, value, onChange, errors}: AttributePropertiesFormProps): ReactElement {
        if (value.type !== AttributePropertiesType.CURRENCY) {
            throw new Error("Invalid attribute properties type");
        }

        function onCurrencyCodeChange(currencyCode: string | undefined) {
            onChange({...value, currencyCode: currencyCode ?? null})
        }

        return (
                <CurrencySelectField
                        label={t(StereotypesTranslationKey.CURRENCY)}
                        value={value.currencyCode ?? undefined}
                        onChange={onCurrencyCodeChange}
                        errorMessage={errors.currencyCode} />
        );
    }
}